<template>
  <div class="core">
      <div class="layui-fluid">
          <pub-search :search-type="'add'"  :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="门店表.xlsx">
            <template>
              <button class="layui-btn" title="新增门店" @click="add()">
                <i class="layui-icon">&#xe624;</i>
                新增门店
              </button>
              <button class="layui-btn" title="导入" @click="importExcel()">
                <span style="display:none" id="importWarpper">
                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">
                      <div style="margin-left: 8.33333333%;">
                          <input type="file" id="file" accept=".xls,.xlsx"/>
                         <div style="margin-top:10px;padding-top:5px">
                          <a style="cursor:pointer;color: blue" href="/static/template/门店信息模板.xlsx"
                             class="btn btn-default btn-xs"><i class="fa fa-file-excel-o"></i> 下载模板</a>
                        </div>
                          <font color="red" style="margin-top:10px;display: block;">
                            提示：仅允许导入“xls”或“xlsx”格式文件！
                          </font>
                      </div>
                  </form>
                </span>
                <i class="layui-icon">&#xe624;</i>
                导入
              </button>
            </template>
          </pub-search>
          <layui-table
            ref="clientmd"
            table-name="YW_CUSTOMER_STORE"
            view-name="YW_CUS_STORE_DETAIL_V1"
            :page-size="20"
            :page-range="6"
            :page-options="[10, 20, 50, 100]"
            :skin="'line'"
            :sort="['CREATE_TIME:DESC']"
            :beforeRender="handleBeforeRnder"
            @table-event-edit="edit($event)"
            @table-event-check="check($event)"
            @table-event-del="$refs.clientmd.delRows($event.data)"
          >
            <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <!-- <div title="序号" width="60"  fixed="left" field="_NUMBER" align="center"></div> -->
                <layui-tableconfig :config = "mdTableList"></layui-tableconfig>
                <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                  <script type="text/html" v-pre>
                    <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
                    <a class=" layui-btn-xs" lay-event="edit">编辑</a>
                    <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
                  </script>
                </div>
            </div>
          </layui-table>
      </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'client',
  data () {
    return {
        mdTableList: [
          { field: 'CLIENT_NAME', title: '客户名称', width: 250 },
          { field: 'BRAND_NAME', title: '品牌名称', width: 150},
          { field: 'STORE_BH', title: '门店编码', width: 250 , sort: true},
          { field: 'STORE_NAME', title: '门店名称', width: 200 },
          { field: 'STORE_MANAGER', title: '店长姓名', width: 110 },
          { field: 'STORE_MANAGER_PHONE', title: '店长电话', width: 150 },
          { field: 'PROVINCE_DESC', title: '省' ,  width: 110},
          { field: 'CITY_DESC', title: '市' ,  width: 110},
          { field: 'DISTRICT_DESC', title: '县' ,  width: 110},
          { field: 'ADDRESS', title: '门店地址', width: 200 },
          { field: 'STORE_IT', title: 'IT负责人', width: 110 },
          { field: 'STORE_IT_PHONE', title: '负责人电话', width: 110 },
          { field: 'CREATE_TIME', title: '创建时间', width: 170 },
        ],
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },
        searchConfig: {
          basic: [
            { TYPE:'input', WIDTH: 260, FIELD: 'CLIENT_NAME:2,BRAND_NAME:2,STORE_BH:2,STORE_NAME:2,STORE_MANAGER:2,STORE_MANAGER_PHONE:2,ADDRESS:2,STORE_IT:2,STORE_IT_PHONE:', PLACEHOLDER: '请输入查询条件'},
          ],
          advanced: [
            { TYPE:'input', NAME: '客户名称 :', FIELD:'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '品牌名称 :', FIELD:'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '门店编码 :', FIELD:'STORE_BH:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '门店名称 :', FIELD:'STORE_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '店长姓名 :', FIELD:'STORE_MANAGER:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '店长电话 :', FIELD:'STORE_MANAGER_PHONE:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '门店地址 :', FIELD:'ADDRESS:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: 'IT负责人 :', FIELD:'STORE_IT:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '负责人电话 :', FIELD:'STORE_IT_PHONE:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE: 'date', NAME: '创建时间 :', FIELD: 'CREATE_TIME:2' }
          ],
          showBatch: true
        },
    }
  },
  mounted(){
    this.tableObj = this.$refs.clientmd;
  },
  methods: {
    /**
     * 新增客户
     */
    add () {
      this.baseComponent.smartLoadComponent('storeForm', {tableObj: this.tableObj, formType: 'add', title: '新增门店'});
    },

    edit ($event){
      this.baseComponent.smartLoadComponent('storeForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '编辑门店'});
    },
    check($event){
      this.baseComponent.smartLoadComponent('storeForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看门店'})
    },
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          e.SSD = (e.PROVINCE ? e.PROVINCE : '') + "," + (e.CITY ? e.CITY: '') + "," + (e.DISTRICT ? e.DISTRICT : '');
        })
      }
    },
     importExcel(){
        var that = this;
        this.layui.layer.open({
            type: 1,
            area: ['400px', '230px'],
            fix: false,
            //不固定
            maxmin: true,
            shade: 0.3,
            title: '上传数据',
            content: $('#importWarpper').html(),
            btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
            // 弹层外区域关闭
            shadeClose: true,
            btn1: function(index, layero){
                var file = layero.find('#file').val();
                if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))){
                    that.layer.openAlert("请选择后缀为 “xls”或“xlsx”的文件。");
                    return false;
                }
                var index = layer.load(2, {shade: false});
                var formData = new FormData();
                formData.append("file", layero.find('#file')[0].files[0]);

                $.ajax({
                    url: process.env.API_HOST + '/newData/import/store?token=' + that.security.getToken(),
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST',
                    success: function (result) {
                        layer.closeAll();
                        that.tableObj.load();
                        if(result.errorMsg){
                            that.layer.openAlert(result.errorMsg);
                            return;
                        }
                        layer.close(index);
                        
                    },
                    error: function(err){
                        layer.close(index);
                    }
                });
            }
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/storeManage/index.vue